var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn btn_lg btn_fav btn_icontext",attrs:{"href":"#"}},[_c('i',{staticClass:"f7-icons icon_lg"},[_vm._v("heart_circle")]),_vm._v("\n        "+_vm._s(_vm.count)+"\n    ")])}
var staticRenderFns = []

export { render, staticRenderFns }